import React, { useState } from 'react';
import ContentLoader from 'react-content-loader';
import { LoadingElement } from '../../themes/loading';
import styled from '../../styled';
import Theme from '../../themes';
const getSize = (value, defaultValue = '100%') => {
    switch (typeof value) {
        case 'string':
            return value;
        case 'number':
            return `${value}px`;
        default:
            return defaultValue;
    }
};
const Wrapper = styled.div `
  width: ${props => getSize(props.width, '100%')};
  height: ${props => getSize(props.height, 'auto')};

  > svg {
    display: block;
  }
`;
const shouldWidthEqualsToHeight = (type) => {
    return ['avatarRect', 'avatarCircle'].includes(type);
};
const loadingElementGenerator = (type) => ({ width }) => {
    const [contentWidth, setContentWidth] = useState(0);
    const initContentWidth = element => {
        if (element) {
            setContentWidth(element.clientWidth);
        }
    };
    return (React.createElement(Wrapper, { ref: initContentWidth, width: width, height: LoadingElement.types[type].height },
        React.createElement(ContentLoader, { primaryColor: Theme.colors.INK_400, primaryOpacity: 0.2, secondaryColor: Theme.colors.INK_400, secondaryOpacity: 0.1, speed: 1.5, style: {
                width: '100%',
                height: shouldWidthEqualsToHeight(type)
                    ? `${contentWidth}px`
                    : `${LoadingElement.types[type].height}px`,
            }, width: contentWidth, height: shouldWidthEqualsToHeight(type)
                ? contentWidth
                : LoadingElement.types[type].height }, type === 'avatarCircle' ? (React.createElement("circle", { cx: contentWidth / 2, cy: contentWidth / 2, r: contentWidth / 2 })) : (React.createElement("rect", { x: "0", y: "0", rx: LoadingElement.types[type].borderRadius, ry: LoadingElement.types[type].borderRadius, width: contentWidth, height: shouldWidthEqualsToHeight(type)
                ? contentWidth
                : LoadingElement.types[type].height })))));
};
export const BodyText = loadingElementGenerator('bodyText');
export const DisplayText = loadingElementGenerator('displayText');
export const SparkLine = loadingElementGenerator('sparkLine');
export const AvatarRect = loadingElementGenerator('avatarRect');
export const AvatarCircle = loadingElementGenerator('avatarCircle');
//# sourceMappingURL=Elements.js.map